export const InvoiceTransitions = {
  cancel: {
    transitionString: 'Cancel',
    transitionAction: 'cancelInvoice',
    confirmationMessage: (invoice: any) => {
      return `Invoice #: ${invoice.human_id} will be canceled with a credit memo.`
    },
  },
}

// TODO (KS): remove deprecated DRAFT after all invoices are migrated to OPEN
export const InvoiceFSMTransitions: Record<string, any> = {
  DRAFT: [InvoiceTransitions.cancel],
  OPEN: [InvoiceTransitions.cancel],
  READY_FOR_RECON: [InvoiceTransitions.cancel],
}

export const getInvoiceTransitionProps = (invoice: any) => {
  const status = invoice.status
  if (!Object.keys(InvoiceFSMTransitions).includes(status)) {
    return null
  }
  return InvoiceFSMTransitions[status]
}
